import React from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router";

import {
  getAvailableProducts,
  isLoadingAvailableProducts,
  getFatalError
} from "state/app/selectors";

import UserIdentityValidator from "components/UserIdentityValidator";
import AppBar from "components/app/bar/AppBar";
import HomePage from "components/app/home/HomePage";
import InfoPage from "components/app/info/InfoPage";
import HelpPage from "components/app/help/HelpPage";
import MainMenu from "components/app/MainMenu";
import InformationModal from "components/app/InformationModal";
import LoadingPage from "components/LoadingPage";
import NotFoundPage from "components/app/NotFoundPage";
import MainMenuTouchGuard from "components/app/MainMenuTouchGuard";
import FatalErrorReporter from "components/app/error/FatalErrorReporter";
import FatalErrorBoundary from "components/FatalErrorBoundary";
import ProductDownTimeReporter from "components/app/ProductDownTimeReporter";
import CustomerNotices from "components/app/CustomerNotices";
import LoadingFrame from "components/app/LoadingFrame";

import TeachersRootPage from "components/teachers/TeachersPage";
import SchoolMoneyRootPage from "components/school_money/SchoolMoneyPage";

class RootPage extends React.Component {

  render() {
    const { availableProducts, isLoading, hasFatalError } = this.props;
    const hasTeachers = availableProducts.includes("teachers");
    const hasSchoolMoney = availableProducts.includes("school_money");
    return (
      <div className="app">
        <FatalErrorReporter />
        <UserIdentityValidator />
        <ProductDownTimeReporter />
        <CustomerNotices />
        <LoadingFrame />
        <FatalErrorBoundary>
          <MainMenuTouchGuard />
          <AppBar />
          <MainMenu />
          <InformationModal />
          <div className="page-container">
            {
              hasFatalError ?
              null :
              <Switch>
                { isLoading ? <Route component={LoadingPage} /> : null }
                <Route path="/info/" component={InfoPage} />
                <Route path="/help/" component={HelpPage} />
                { hasTeachers ? <Route path="/teachers/" component={TeachersRootPage} /> : null }
                { hasSchoolMoney ? <Route path="/school_money/" component={SchoolMoneyRootPage} /> : null }
                <Route path="/" exact component={HomePage} />
                <Route component={NotFoundPage} />
              </Switch>
            }
          </div>
        </FatalErrorBoundary>
      </div>

    );
  }

}

export default connect(
  state => ({
    availableProducts: getAvailableProducts(state),
    isLoading: isLoadingAvailableProducts(state),
    hasFatalError: getFatalError(state) !== null
  }),
  undefined,
  undefined,
  // components depends on routing
  { pure: false }
)(RootPage);



// WEBPACK FOOTER //
// ./src/components/RootPage.js